import { ElMessage, ElMessageBox } from 'element-plus';

// Point d'entrée unique pour informer l'utilisateur (succès, erreurs serveur, confirmations).
// Ne pas utiliser alert() / confirm() dans les vues.

const DEFAULT_ERROR = 'Une erreur est survenue';
const NETWORK_ERROR = 'Serveur injoignable, vérifiez votre connexion';

const show = (type, message, duration = 3000) =>
  ElMessage({ type, message, showClose: true, grouping: true, duration });

export const notifySuccess = (message) => show('success', message);
export const notifyInfo = (message) => show('info', message);
export const notifyWarning = (message) => show('warning', message, 4000);

// Extrait un message lisible d'une erreur axios (ou affiche directement une chaîne)
export const errorMessage = (error, fallback = DEFAULT_ERROR) => {
  if (typeof error === 'string') return error;
  if (!error) return fallback;
  if (!error.response) {
    // Requête partie mais aucune réponse : serveur arrêté ou réseau coupé
    return error.request ? NETWORK_ERROR : fallback;
  }
  const data = error.response.data || {};
  return data.message || data.errors?.[0]?.msg || fallback;
};

export const notifyError = (error, fallback = DEFAULT_ERROR) =>
  show('error', errorMessage(error, fallback), 5000);

// Boîte de confirmation : résout true si l'utilisateur confirme, false sinon
export const confirmAction = (message, { title = 'Confirmation', confirmText = 'Confirmer', type = 'warning' } = {}) =>
  ElMessageBox.confirm(message, title, {
    confirmButtonText: confirmText,
    cancelButtonText: 'Annuler',
    type,
  })
    .then(() => true)
    .catch(() => false);

// Boîte de saisie : résout le texte saisi (non vide), ou null si l'utilisateur annule
export const promptText = (message, { title = 'Saisie', confirmText = 'Valider', placeholder = '', maxLength = 500 } = {}) =>
  ElMessageBox.prompt(message, title, {
    confirmButtonText: confirmText,
    cancelButtonText: 'Annuler',
    inputPlaceholder: placeholder,
    inputType: 'textarea',
    inputValidator: (value) => {
      const text = (value || '').trim();
      if (!text) return 'Ce champ est requis';
      if (text.length > maxLength) return `${maxLength} caractères maximum`;
      return true;
    },
  })
    .then(({ value }) => value.trim())
    .catch(() => null);
